import { render, staticRenderFns } from "./RewardProgramPanel.vue?vue&type=template&id=4f0a813c&scoped=true"
import script from "./RewardProgramPanel.vue?vue&type=script&lang=js"
export * from "./RewardProgramPanel.vue?vue&type=script&lang=js"
import style0 from "./RewardProgramPanel.vue?vue&type=style&index=0&id=4f0a813c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a813c",
  null
  
)

export default component.exports